import { StratCmsClient, StratCmsError, browserSession, type Principal } from "@stratcms/sdk";

export const CSRF_COOKIE = "__Host-stratcms_csrf";

function readCookie(name: string): string | null {
  for (const part of document.cookie.split(";")) {
    const [k, ...v] = part.trim().split("=");
    if (k === name) return decodeURIComponent(v.join("="));
  }
  return null;
}

export const api = new StratCmsClient({
  baseUrl: location.origin,
  auth: browserSession(() => readCookie(CSRF_COOKIE)),
  credentials: "same-origin",
  retries: 1,
});

export const session: { me: Principal | null; devLogin: boolean } = { me: null, devLogin: false };

export function can(scope: string): boolean {
  return !!session.me?.scopes.includes(scope as never);
}

export function isApprover(): boolean {
  return session.me?.kind === "human" && (session.me.role === "approver" || session.me.role === "admin");
}

export function explain(e: unknown): string {
  if (e instanceof StratCmsError) {
    const hint: Record<string, string> = {
      STALE_VERSION: " Reload to see the newest version.",
      CONFLICT: " Reload and try again.",
      CSRF_FAILED: " Reload the page.",
      UNAUTHENTICATED: " Sign in again.",
    };
    return `${e.message}${hint[e.code] ?? ""}`;
  }
  return (e as Error)?.message || "Something went wrong.";
}

export async function postJson(path: string, body: unknown): Promise<Response> {
  const csrf = readCookie(CSRF_COOKIE);
  return fetch(path, { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json", ...(csrf ? { "x-csrf-token": csrf } : {}) }, body: JSON.stringify(body) });
}
